import { useState, createContext, useContext } from "react";
const useTicketCntx = createContext();
const setTicketCntx = createContext();
export function TicketCntx({ children }) {
  const [stTicket, setStTicket] = useState({
    SearchTickets: "",
    NavbarItem: "",
  });
  return (
    <useTicketCntx.Provider value={stTicket}>
      <setTicketCntx.Provider value={setStTicket}>
        {children}
      </setTicketCntx.Provider>
    </useTicketCntx.Provider>
  );
}
export function UseTicket() {
  return useContext(useTicketCntx);
}
export function SetTicket() {
  return useContext(setTicketCntx);
}
